import type { SurveyFormData } from '../../../../contexts/SurveyContext';

export type FormData = SurveyFormData;

export interface StepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string | string[]) => void;
  onNext: () => void;
  onBack: () => void;
}

export const TOTAL_STEPS = 4;